export default "__VITE_ASSET__BXM_S2Hz__"